/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    PUBLISHED: 'published',
    DRAFT: 'draft',
};
